import { findAll } from '@/api/tlds.api'
import decoder from '@/decoders/tlds'
import useAPI from '../useAPI'

export default () => useAPI({
  request: findAll,
  decoder
})
